// removed by extract-text-webpack-plugin
module.exports = {"calendar-container":"src-modules-calendar-CalendarView-__CalendarView__calendar-container--VpqFA"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/calendar/CalendarView/CalendarView.less
// module id = 1881
// module chunks = 0